<template>
  <ol class="docs-steps">
    <li>Fill in your details in the generator and click <b>Copy Signature</b>.</li>
    <li>In Outlook click the <b>gear icon</b> (top right) to open <b>Settings</b>.</li>
    <li>Go to <b>Account → Signatures</b> and click <b>+ Add signature</b>.</li>
    <li>
      Type a name for the signature (e.g. “No. J Signature”), then click in the body area and paste
      (<kbd class="docs-kbd">⌘ V</kbd> / <kbd class="docs-kbd">Ctrl V</kbd>).
    </li>
    <li>
      Tick <b>Set default for new messages</b> and <b>Set default for replies and forwards</b>,
      then click <b>Save</b>.
    </li>
    <li>Close Settings and click <b>New mail</b> to check the result.</li>
  </ol>
</template>
